/*
 * takes two arrays and returns a boolean indicating whether or not
 * the first array includes any of the second array's valuess
 *
 * arrayIncludesAnyOf([ 2, 5, 8 ], [ 5 ]) -> true
 * 
 * arrayIncludesAnyOf([ 2, 5, 8 ], [ 5, 8 ]) -> true
 * 
 * arrayIncludesAnyOf([ 2, 5, 8 ], [ 10 ]) -> false
 */
module.exports = function arrayIncludesAnyOf (array, anyOf) {
  return array.some(anyOf.includes.bind(anyOf))
}
